module.exports = __webpack_public_path__ + "img/pictureCircle.e0244484.png";